import {adminHttp} from "~/Admin/services/http";

export const loadConfig = () => async (dispatch) => {

    const userResponse = await adminHttp.get('/config');

    dispatch({
        type: 'CONFIG_LOADED',
        payload: userResponse.data || null
    });
};
